import Skeleton from '@mui/material/Skeleton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import type { DecoratedUnisonProjectTask } from '@witmetrics/utils';
import UnisonProjectTaskListItem, {
  type UnisonProjectTaskListItemProps,
} from './UnisonProjectTaskListItem';
import { classes, styles } from './utils';

export { UnisonProjectTaskListItem, type UnisonProjectTaskListItemProps };

export type UnisonProjectTasksListProps = {
  isFetchingData?: boolean;
  condensed?: boolean;
  className?: string;
  unisonProjectTasks: DecoratedUnisonProjectTask[];
};

export default function UnisonProjectTasksList({
  isFetchingData,
  condensed,
  className,
  unisonProjectTasks = [],
}: UnisonProjectTasksListProps) {
  const sortedTasks = unisonProjectTasks.sort((a, b) => {
    if (b.task.dueAt > a.task.dueAt) return -1;
    if (a.task.dueAt > b.task.dueAt) return 1;
    return 0;
  });

  return (
    <List className={className}>
      {isFetchingData
        ? [0, 0.2, 0.3].map((delay) => (
            <ListItem
              key={delay}
              disablePadding
              className={classes.skeletonItem}>
              <Skeleton
                sx={styles.skeleton(delay)}
                className={classes.skeleton}
                variant="rectangular"
                animation="wave"
              />
            </ListItem>
          ))
        : sortedTasks.map((upt) => (
            <UnisonProjectTaskListItem
              key={upt.task.id}
              condensed={condensed}
              unisonProjectTask={upt}
            />
          ))}
    </List>
  );
}
